import { Image, Typography } from "antd";
import React from "react";
import Mail_Icon from "../../../assets/images/Mail_icon.png";

export const SuccessEvent: React.FC = (): React.ReactElement => {
  return (
    <div className="text-center pt-[30px]">
      <Image preview={false} src={Mail_Icon} />
      <Typography className="text-[#54565A] font-bold text-[24px] mt-[32px]">{`Check your email`}</Typography>
      <Typography className="text-[#54565A]">{`We have sent you a QR Code and Agenda to your registered email address.`}</Typography>
    </div>
  );
};
